import React from 'react';
import QuoteButton from '../Quote/QuoteButton';

const CallToAction = ({ onQuoteClick }) => (
  <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-white px-4">
    <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 tracking-tight">
      Your Friendly Neighborhood Movers
    </h1>
    <p className="text-xl md:text-2xl mb-8 text-center">
      The Moving Solution You Need!
    </p>
    <div className="block md:hidden">
      <QuoteButton onClick={onQuoteClick} />
    </div>
  </div>
);

export default CallToAction;